module.exports = __webpack_public_path__ + "img/oakchevron913m_detail_rsh1.8212bbd3.jpg";